import React, {useState} from 'react';
import {useHistory} from 'react-router-dom'
import {Menu} from 'antd';
import PropTypes from 'prop-types';

import './nav.scss';

Nav.propTypes = {
    menu: PropTypes.object
};

function Nav(props) {
    const {menu} = props
    const [active, setActive] = useState(menu.activate);
    let history = useHistory()
    function menuClick (e) {
        setActive(e.key);
        history.push(e.key);
    }

    return (
        <Menu className='ant-col ant-col-4' onClick={menuClick} selectedKeys={active} mode="vertical">
            {
                menu.menuItems.map((item) => {
                    return (
                        <Menu.Item key={item.key}>
                            {item.title}
                        </Menu.Item>
                    )
                })
            }
        </Menu>
    );
}

export default Nav;
